export const getTimeslotsEndpoint = (date: string, all: boolean) =>
    `/api/timeslots?date=${date}&all=${all}`;

export const DELETE_REQUESTS = '/api/timeslots/delete-requests/';
